var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-dropdown-clients',{attrs:{"value":_vm.value,"name":_vm.value ? '' : 'Selecciona el cliente',"first-option":_vm.firstOption,"variant":"white","search-placeholder":"Buscar cliente"},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }